import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Powaimumbaipunecabservice() {



  const cardData = {


  keyword: "Powai Mumbai Pune Cab Service",

  headingDescription: "Trustline Travels offers reliable Powai Mumbai to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family vacations, and outstation journeys. Whether you require a one-way taxi or a round-trip cab, our experienced chauffeurs ensure timely pickups, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Powai to Pune. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Powai Mumbai to Pune taxi services.",

  topPlaces: [
    {
      title: "Magarpatta City",
      description: "Magarpatta City is one of Pune's most prominent business townships, featuring world-class IT parks, multinational companies, corporate offices, shopping destinations, and residential communities. It is a preferred destination for professionals and business travelers."
    },
    {
      title: "Balewadi High Street",
      description: "Balewadi High Street is a vibrant commercial and lifestyle destination offering premium restaurants, cafés, offices, retail outlets, and entertainment venues. It is popular among professionals, families, and visitors."
    },
    {
      title: "Kondhwa",
      description: "Kondhwa is a rapidly developing residential and commercial locality with educational institutions, hospitals, business establishments, shopping centers, and excellent road connectivity across Pune."
    },
    {
      title: "Ranjangaon MIDC",
      description: "Ranjangaon MIDC is one of Maharashtra's leading industrial hubs, housing engineering companies, automobile manufacturers, pharmaceutical industries, and logistics centers. It is an important destination for industrial and corporate travel."
    },
    {
      title: "Talawade IT Park",
      description: "Talawade IT Park is an emerging technology hub featuring software companies, IT firms, corporate offices, and modern business infrastructure. It is a preferred destination for professionals and technology businesses."
    },
    {
      title: "Pune Railway Station",
      description: "Pune Railway Station is one of the city's busiest transportation hubs, providing excellent rail connectivity across India. It is a convenient destination for passengers requiring reliable cab services."
    },
    {
      title: "Shaniwar Wada",
      description: "Shaniwar Wada is Pune's iconic historical landmark, renowned for its magnificent Maratha architecture, cultural significance, and evening light-and-sound show. It is one of the city's top tourist attractions."
    },
    {
      title: "Empress Garden",
      description: "Empress Garden is a beautiful botanical garden featuring colorful flowers, lush greenery, walking paths, and peaceful surroundings. It is a favorite destination for families, photographers, and nature lovers."
    },
    {
      title: "Pawna Lake",
      description: "Pawna Lake is a picturesque destination near Pune, famous for lakeside camping, scenic mountain views, boating, and relaxing weekend getaways. It is popular among adventure seekers and families."
    },
    {
      title: "Lohagad Fort",
      description: "Lohagad Fort is one of Maharashtra's most famous hill forts, known for its trekking trails, panoramic valley views, historic architecture, and breathtaking monsoon scenery. It attracts trekkers and history enthusiasts throughout the year."
    }
  ],






"services": [
  {
    "name": "Powai to Pune Cab",
    "description": "Book Powai to Pune Cab with fixed fares, AC vehicles, experienced chauffeurs, doorstep pickup, comfortable seating, and safe intercity travel for business, family, airport, and leisure trips."
  },
  {
    "name": "Powai to Pune Cab Fare",
    "description": "Check Powai to Pune Cab Fare with transparent pricing, affordable rates, multiple cab options including Sedan, Ertiga, Innova Crysta, and no hidden charges."
  },
  {
    "name": "Powai to Pimpri Cab Fare",
    "description": "Reserve Powai to Pimpri Cab with affordable fares, professional drivers, clean AC cars, and reliable pickup and drop service."
  },
  {
    "name": "Powai to Pimpri Chinchwad Cab",
    "description": "Book Powai to Pimpri Chinchwad Cab for comfortable outstation travel with fixed pricing, experienced chauffeurs, and premium vehicles."
  },
  {
    "name": "Powai to Baner Cab",
    "description": "Choose Powai to Baner Cab for safe, convenient, and affordable travel with punctual pickup and comfortable AC vehicles."
  },
  {
    "name": "Powai to Pune Station Cab",
    "description": "Travel from Powai to Pune Station with reliable cab service, professional drivers, fixed fares, and doorstep pickup."
  },
  {
    "name": "Powai to Viman Nagar Cab",
    "description": "Book Powai to Viman Nagar Cab with affordable pricing, experienced chauffeurs, clean vehicles, and comfortable highway travel."
  },
  {
    "name": "Powai to Hadapsar Cab",
    "description": "Reserve Powai to Hadapsar Cab for business and family travel with AC vehicles, transparent pricing, and reliable service."
  },
  {
    "name": "Powai to Magarpatta Cab",
    "description": "Choose Powai to Magarpatta Cab with premium cars, professional drivers, fixed fares, and convenient intercity transportation."
  },
  {
    "name": "Powai to Hinjewadi Cab Fare",
    "description": "Check Powai to Hinjewadi Cab Fare with affordable pricing, comfortable vehicles, and dependable chauffeur-driven service."
  },
  {
    "name": "Cab Service in Powai Mumbai",
    "description": "Our Cab Service in Powai Mumbai provides local and outstation taxi services with clean vehicles, professional drivers, instant booking, and affordable fares."
  },
  {
    "name": "Powai to Pune Ertiga Taxi",
    "description": "Book Powai to Pune Ertiga Taxi for spacious family travel with comfortable seating, ample luggage space, and affordable SUV pricing."
  },
  {
    "name": "Powai to Pune Innova Crysta",
    "description": "Hire Powai to Pune Innova Crysta for premium outstation travel with luxury seating, experienced chauffeurs, and smooth highway journeys."
  },
  {
    "name": "Powai to Pune Round Trip Taxi",
    "description": "Reserve Powai to Pune Round Trip Taxi with flexible return timing, fixed fares, premium vehicles, and reliable chauffeur service."
  },
  {
    "name": "Taxi Service in Powai Mumbai",
    "description": "Choose Taxi Service in Powai Mumbai for comfortable local and intercity travel with verified drivers, AC vehicles, and transparent pricing."
  },
  {
    "name": "Cheapest Taxi Service in Powai Mumbai",
    "description": "Book the Cheapest Taxi Service in Powai Mumbai offering budget-friendly fares, clean cars, experienced chauffeurs, and reliable transportation."
  },
  {
    "name": "Best Taxi Service in Powai Mumbai",
    "description": "Experience the Best Taxi Service in Powai Mumbai with premium vehicles, courteous drivers, instant booking, and dependable customer support."
  },
  {
    "name": "Powai to Pune Taxi",
    "description": "Reserve Powai to Pune Taxi with fixed fares, AC cars, trained drivers, doorstep pickup, and comfortable long-distance travel."
  },
  {
    "name": "Powai to Pune Cab Service",
    "description": "Our Powai to Pune Cab Service offers one-way and round-trip travel with Sedan, Ertiga, Innova Crysta, and professional chauffeurs."
  },
  {
    "name": "Powai to Pune One Way Cab",
    "description": "Book Powai to Pune One Way Cab for direct travel with affordable pricing, clean AC vehicles, and no return fare charges."
  },
  {
    "name": "Powai to Pune Taxi Booking",
    "description": "Complete Powai to Pune Taxi Booking online with instant confirmation, secure reservations, fixed fares, and multiple vehicle options."
  },
  {
    "name": "Powai to Pune Drop Taxi",
    "description": "Choose Powai to Pune Drop Taxi for reliable one-way travel with experienced chauffeurs and comfortable AC vehicles."
  },
  {
    "name": "Powai to Pune Online Cab Booking",
    "description": "Book Powai to Pune Online Cab Booking with quick confirmation, transparent pricing, and 24x7 booking support."
  },
  {
    "name": "Powai to Pune Private Cab",
    "description": "Travel comfortably with Powai to Pune Private Cab offering exclusive chauffeur-driven vehicles, flexible timing, and premium service."
  },
  {
    "name": "Powai to Pune Outstation Cab",
    "description": "Reserve Powai to Pune Outstation Cab for safe, affordable, and comfortable long-distance travel with professional drivers."
  },
  {
    "name": "Powai to Pune Cheap Cab",
    "description": "Book Powai to Pune Cheap Cab with economical fares, clean vehicles, experienced chauffeurs, and dependable service."
  },
  {
    "name": "Powai to Pune AC Cab Service",
    "description": "Travel in comfort with Powai to Pune AC Cab Service featuring air-conditioned cars, courteous drivers, and fixed pricing."
  },
  {
    "name": "Powai to Pune Innova Cab",
    "description": "Hire Powai to Pune Innova Cab for family tours, corporate travel, airport transfers, and spacious outstation journeys."
  },
  {
    "name": "Powai to Pune Taxi Fare",
    "description": "Check Powai to Pune Taxi Fare with transparent pricing, affordable packages, and multiple vehicle choices."
  },
  {
    "name": "Powai Mumbai to Pune Cab",
    "description": "Book Powai Mumbai to Pune Cab with doorstep pickup, professional chauffeurs, AC vehicles, and safe intercity transportation."
  },
  {
    "name": "Powai to Pune Taxi Service",
    "description": "Choose Powai to Pune Taxi Service for reliable one-way and round-trip travel with premium vehicles and experienced drivers."
  },
  {
    "name": "Powai to Pune Round Trip Cab",
    "description": "Reserve Powai to Pune Round Trip Cab with flexible schedules, affordable fares, and comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Powai to Pune Cab Per Km Rate",
    "description": "Check Powai to Pune Cab Per Km Rate with transparent pricing, fixed packages, and economical travel options."
  },
  {
    "name": "Powai to Pune Sedan Taxi",
    "description": "Book Powai to Pune Sedan Taxi for comfortable, affordable, and reliable intercity travel with clean AC sedans."
  },
  {
    "name": "Powai to Pune Innova Crysta Cab",
    "description": "Choose Powai to Pune Innova Crysta Cab for premium travel with luxury seating, spacious interiors, and professional chauffeurs."
  }
],

"tableData": [
  ["Powai to Pune Cab", "Powai to Pune Cab Fare"],
  ["Powai to Pimpri Cab Fare", "Powai to Pimpri Chinchwad Cab"],
  ["Powai to Baner Cab", "Powai to Pune Station Cab"],
  ["Powai to Viman Nagar Cab", "Powai to Hadapsar Cab"],
  ["Powai to Magarpatta Cab", "Powai to Hinjewadi Cab Fare"],
  ["Cab Service in Powai Mumbai", "Powai to Pune Ertiga Taxi"],
  ["Powai to Pune Innova Crysta", "Powai to Pune Round Trip Taxi"],
  ["Taxi Service in Powai Mumbai", "Cheapest Taxi Service in Powai Mumbai"],
  ["Best Taxi Service in Powai Mumbai", "Powai to Pune Taxi"],
  ["Powai to Pune Cab Service", "Powai to Pune One Way Cab"],
  ["Powai to Pune Taxi Booking", "Powai to Pune Drop Taxi"],
  ["Powai to Pune Online Cab Booking", "Powai to Pune Private Cab"],
  ["Powai to Pune Outstation Cab", "Powai to Pune Cheap Cab"],
  ["Powai to Pune AC Cab Service", "Powai to Pune Innova Cab"],
  ["Powai to Pune Taxi Fare", "Powai Mumbai to Pune Cab"],
  ["Powai to Pune Taxi Service", "Powai to Pune Round Trip Cab"],
  ["Powai to Pune Cab Per Km Rate", "Powai to Pune Sedan Taxi"],
  ["Powai to Pune Innova Crysta Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Trusted Powai Mumbai to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides reliable cab services from Powai, Mumbai to Pune with comfortable vehicles, experienced chauffeurs, and convenient intercity travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Powai",
    WhyChoosedescription: "Enjoy hassle-free pickup from Hiranandani Gardens, IIT Powai, offices, hotels, residential complexes, and nearby areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Safe & Comfortable Expressway Journey",
    WhyChoosedescription: "Our professional drivers ensure a smooth, secure, and punctual journey with excellent knowledge of the Mumbai–Pune Expressway."
  },
  {
    WhyChooseheading: "Wide Range of Premium Vehicles",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel requirements and group size."
  },
  {
    WhyChooseheading: "Affordable Pricing with Full Transparency",
    WhyChoosedescription: "Receive clear fare details before booking with competitive rates and no hidden charges for your Powai to Pune journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Book one-way cabs, return journeys, or customized travel packages based on your travel schedule and destination."
  },
  {
    WhyChooseheading: "Ideal for Corporate & Family Travel",
    WhyChoosedescription: "Our Powai to Pune cab service is suitable for business meetings, airport transfers, family trips, educational visits, and personal travel."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Assistance",
    WhyChoosedescription: "Book your Powai Mumbai to Pune cab anytime with instant confirmation and dedicated customer support for a seamless travel experience."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Powai Mumbai to Pune cab service?",
    answer: "Yes, Trustline Cab offers reliable cab services from Powai, Mumbai to Pune for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Powai to Pune?",
    answer: "Yes, one-way cab services are available with convenient pickup from Powai and direct drop at your preferred Pune destination."
  },
  {
    question: "Do you provide pickup from Hiranandani Gardens and IIT Powai?",
    answer: "Yes, we provide doorstep pickup from Hiranandani Gardens, IIT Powai, residential societies, offices, hotels, and nearby locations."
  },
  {
    question: "Which vehicles are available for Powai to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable intercity travel."
  },
  {
    question: "Is Powai to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7, allowing you to travel at your preferred time."
  },
  {
    question: "Can I reserve a return cab from Pune to Powai?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Powai."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in the confirmed booking quotation."
  },
  {
    question: "Should I book my Powai to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and your preferred pickup timing."
  },
  {
    question: "Do you provide Powai to Pune cabs for corporate travel?",
    answer: "Yes, our services are suitable for business meetings, employee transportation, client visits, and regular corporate travel."
  },
  {
    question: "How can I book Powai Mumbai to Pune Cab Service with Trustline Travels?",
    answer: "Share your pickup location in Powai, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Keshav Nair",
    feedback: "The Powai to Pune journey was comfortable from start to finish. The driver arrived on time, the vehicle was clean, and the travel experience exceeded our expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Menon",
    feedback: "Trustline Travels provided outstanding service with easy booking, professional communication, and a smooth ride. Our trip from Powai to Pune was relaxing and perfectly managed.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Powai Mumbai Pune Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/powai-mumbai-pune-cab-service.webp",
  "description":
    "Book Powai Mumbai Pune Cab Service with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Powai to Pune, Pimpri Chinchwad, Baner, Viman Nagar, Hadapsar, Magarpatta, Hinjewadi, Pune Railway Station, and all Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/powai-mumbai-pune-cab-service"
  }
};





  return (
    <div>
<Helmet>
  <title>Powai Mumbai Pune Cab Service | One Way Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Powai Mumbai Pune Cab Service with Trustline Travels for reliable one-way and round-trip taxi services. Travel from Powai to Pune, Pimpri Chinchwad, Baner, Viman Nagar, Hadapsar, Magarpatta, Hinjewadi, and Pune Railway Station with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="Powai to Pune Cab, Powai to pune cab fare, powai to pimpri cab fare, powai to pimpri chinchwad cab, powai to baner cab, powai to pune station cab, powai to viman nagar cab, powai to hadapsar cab, powai to magarpatta cab, powai to hinjewadi cab fare, cab service in powai mumbai, powai to pune ertiga taxi, powai to pune innova crysta, powai to pune round trip taxi, cab service in powai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/115.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Powaimumbaipunecabservice;